module.exports = __webpack_public_path__ + "static/media/minimize.8cf3193d.svg";